// extracted by mini-css-extract-plugin
export default {"show-submenu":"styles_show-submenu__7anFv","hide-submenu":"styles_hide-submenu__7whEw","unit-actions-panel":"styles_unit-actions-panel__9KGck"};